import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          精彩推荐
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer"
            >
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="640"
                  height="360"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/80 text-primary-500">
                    <i className="ri-play-circle-line text-3xl"></i>
                  </span>
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-900 mb-2 line-clamp-2">{item.title}</h3>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-eye-line"></i>
                  </span>
                  <span>{item.views} 次浏览</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}